<app-dropdown-c class="animated fadeIn" style="width: 100%;"
				*ngIf="tableQueryTemplatesService.isEnabled && tableQueryTemplatesService.templates?.length"
				text="{{tableQueryTemplatesService.selectedTemplate?.name || 'Select template'}}"
				[enableSearch]="true"
				itemDisplayKey="name"
				[items]="tableQueryTemplatesService.templates"
				(onItemClicked)="selectQueryTemplate($event.item)"
				(onItemDelete)="tableQueryTemplatesService.deleteQueryTemplate($event.item)">
</app-dropdown-c>
